import React from 'react';

import { SubHeading } from '../../components';
import { images } from '../../constants';

const FindUs = () => (
  <div className="app__bg app__wrapper section__padding" id="contact">
    <div className="app__wrapper_info">
      <SubHeading title="Contact" />
      <h1 className="headtext__cormorant" style={{ marginBottom: '1rem' }}>Find Us</h1>
      <div className="app__wrapper-content">
        <p className="p__cormorant" style={{ color: '#DCCA87', margin: '2rem 0' }}>Reservations</p>
        <p className="p__opensans">+1 405-275-5650</p>
        <p className="p__cormorant" style={{ color: '#DCCA87', margin: '2rem 0' }}>Location</p>
        <p className="p__opensans">120 West MacArthur St Shawnee, OK 74804, United States</p>
        <p className="p__cormorant" style={{ color: '#DCCA87', margin: '2rem 0' }}>Working Hours</p>
        <p className="p__opensans">Tue - Sat: 11:00 am - 08:30 pm</p>
        <p className="p__opensans">Closed Sun - Mon</p>
        <div style={{ marginBottom: '2rem' }} />
      </div>
      <a href="mailto:paulsplacesteak@sbcglobal.net">
        <button type="submit" className="custom__button">Email Us</button>
      </a>
    </div>

    <div className="app__wrapper_img">
      <img src={images.findus} alt="findus_img" />
    </div>
  </div>
);

export default FindUs;